import { api } from './api';
import { buildFormData } from './utils';

/**
 * Status
 * --------------
 */
export function getStatus() {
  return api.get(`/noauth-status`);
}

/**
 * BRANDS
 * --------------
 */
export function getBrands(params) {
  return api.get(`/brands`, {
    params
  });
}

/**
 * CUSTOMERS
 * --------------
 */

export function getCustomers(params) {
  return api.get(`/customers`, {
    params
  });
}
export function getCustomersTotals(params) {
  return api.get(`/customers/totals`, {
    params
  });
}
export function getCustomer(id) {
  return api.get(`/customers/${id}`);
}
export function getCustomerByRef(entityRef, entitySource) {
  return api.get(`/customers/by-ref`, {
    params: {
      entity_ref: entityRef,
      entity_source: entitySource
    }
  });
}
export function getCustomerDetails(id) {
  return api.get(`/customers/${id}/details`);
}
export function getCustomerMessages(id, params) {
  // We're appending an abort controller to the promise. This allows us to cancel the request.
  const controller = new AbortController();
  const promise = api.get(`/customers/${id}/messages`, {
    params,
    signal: controller.signal
  });
  promise.controller = controller;
  return promise;
}
export function sendCustomerMessage(id, data) {
  return api.post(`/customers/${id}/messages`, data);
}
export function getCustomerActions(id, params) {
  return api.get(`/customers/${id}/actions`, {
    params
  });
}
export function unsubscribeEmail(company, email, email_optstatus_id, status) {
  if (email_optstatus_id) {
    return api.patch(`/unsubscribes/${email_optstatus_id}`, {
      status
    });
  }
  return api.post(`/unsubscribes`, {
    company,
    email,
    status
  });
}
export function updateSMSStatus(company, phone, sms_optstatus_id, status) {
  if (sms_optstatus_id) {
    return api.patch(`/sms-optstatuses/${sms_optstatus_id}`, {
      status
    });
  }
  return api.post(`/sms-optstatuses`, {
    company,
    phone,
    status
  });
}
export function getOptStatusSMS(params) {
  return api.get(`/sms-optstatuses`, {
    params
  });
}
export function unsubscribeEmailDelete(unsubscribe_id) {
  return api.delete(`/unsubscribes/${unsubscribe_id}`);
}
export function getCustomerRefGroups(params) {
  return api.get(`/customer-ref-groups`, {
    params
  });
}
export function createCustomerRefGroups(data) {
  return api.post(`/customer-ref-groups`, data);
}
export function editCustomerRefGroup(id, data) {
  return api.patch(`customer-ref-groups/${id}`, data);
}
export function editCustomer(id, data) {
  return api.patch(`/customers/${id}`, data);
}
export function getCustomerScheduleTypes(id, params) {
  return api.get(`/customers/${id}/schedules`, {
    params
  });
}
export function createNewCustomerRef(data) {
  return api.post(`/customer-refs`, data);
}
export function getCustomerRef(id, params) {
  return api.get(`/customer-refs/${id}`, {
    params
  });
}
export function getCustomerRefs(params) {
  return api.get(`/customer-refs`, {
    params
  });
}
export function performManualReviewMatch(id, data) {
  return api.post(`/customer-refs/${id}/manual-review-match`, data);
}
export function deleteCustomerRefsVehicle(id) {
  return api.delete(`/customer-refs/vehicles/${id}`);
}
export function retireCustomerRefsVehicle(companyId, data) {
  return api.post(`/customer-refs/vehicles/remove?company=${companyId}`, data);
}
export function restoreCustomerRefsVehicle(companyId, data) {
  return api.post(`/customer-refs/vehicles/restore?company=${companyId}`, data);
}
export function splitCustomerRefs(data) {
  return api.post(`/customer-refs/split`, data);
}
export function getCustomerSubscriptions(id, params) {
  return api.get(`/customers/${id}/subscriptions`, {
    params
  });
}
export function getCustomerRewards(id, params) {
  return api.get(`/customers/${id}/rewards`, {
    params
  });
}
export function getSchedules(params) {
  return api.get(`/customer-refs/schedules`, {
    params
  });
}
export function getSchedule(id, params) {
  return api.get(`/customer-refs/schedules/${id}`, {
    params
  });
}
export function updateSchedule(id, data) {
  return api.patch(`/customer-refs/schedules/${id}`, data);
}
export function deleteSchedule(id) {
  return api.delete(`/customer-refs/schedules/${id}`);
}

/**
 * CALENDAR SESSIONS
 * --------------
 */
export function getCalendarSessions(params) {
  const controller = new AbortController();
  const promise = api.get(`/calendar/sessions`, {
    params,
    signal: controller.signal
  });
  promise.controller = controller;
  return promise;
}

/**
 * NAICS
 * --------------
 */
export function getNAICS(params) {
  return api.get(`/naics`, {
    params
  });
}

/**
 * USERS
 * --------------
 */
export function getUsers(params) {
  return api.get(`/users`, {
    params
  });
}
export function getUser(id, params) {
  return api.get(`/users/${id}`, {
    params
  });
}
export function updateUser(id, data) {
  return api.patch(`/users/${id}`, data);
}
export function inviteUser(data) {
  return api.post(`/users/invite`, data);
}
export function editUser(id, body) {
  return api.patch(`/users/${id}`, body);
}
export function getUserLocations(params) {
  return api.get(`/users/locations`, {
    params
  });
}
export function replaceUserToLocation(data) {
  return api.post(`/users/to_location/bulk-replace`, data);
}
export function replaceUserToMarket(data) {
  return api.post(`/users/to_market/bulk-replace`, data);
}

/**
 * NotificationContact (Notificaiton Lists)
 */
export function getNotificationContact(id, params) {
  return api.get(`/notification_contacts/${id}`, {
    params
  });
}
export function getNotificationContacts(params) {
  return api.get(`/notification_contacts`, {
    params
  });
}
export function createNotificationContact(data) {
  return api.post(`/notification_contacts`, data);
}
export function updateNotificationContact(id, data) {
  return api.patch(`/notification_contacts/${id}`, data);
}
export function deleteNotificationContact(id) {
  return api.delete(`/notification_contacts/${id}`);
}

/*
 * Notification Logs (in-app notifications for the logged-in user)
 */
export function getNotificationLogs(params) {
  return api.get(`/notification/logs`, {
    params
  });
}
export function getNotificationLog(id, params) {
  return api.get(`/notification/logs/${id}`, {
    params
  });
}
export function markNotificationLogRead(id) {
  return api.post(`/notification/logs/${id}/mark-read`);
}
export function getNotificationLogNewCount(params) {
  return api.get(`/notification/logs/new-count`, {
    params
  });
}

/*
NotificationContactScope (a subset of objects under NotificationContact)
*/
export function getNotificationContactScope(contactId, id, params) {
  return api.get(`/notification_contacts/${contactId}/scope/${id}`, {
    params
  });
}
export function getNotificationContactScopes(contactId, params) {
  return api.get(`/notification_contacts/${contactId}/scope`, {
    params
  });
}

// TODO struggled to get django to play nice with using the contactId in the URL so contactId
// must be passed into the URL as well as the request body, sorry.
export function createNotificationContactScope(contactId, data) {
  return api.post(`/notification_contacts/${contactId}/scope`, data);
}
export function updateNotificationContactScope(contactId, id, data) {
  return api.patch(`/notification_contacts/${contactId}/scope/${id}`, data);
}
export function deleteNotificationContactScope(contactId, id) {
  return api.delete(`/notification_contacts/${contactId}/scope/${id}`);
}

/**
 * ANALYTICS
 * --------------
 */

export function getAnalytics(params) {
  return api.get(`/analytics/views`, {
    params: {
      ordering: 'display_name',
      ...params
    }
  });
}
export function getUserAvailableViews(params) {
  return api.get(`/analytics/user-available-views`, {
    params
  });
}
export function saveUserAvaliableViews(data) {
  return api.post(`/analytics/user-available-views/bulk`, data);
}
export function getScheduledReports(params) {
  return api.get(`/analytics/scheduled-reports`, {
    params
  });
}
export function createScheduledReport(data) {
  return api.post(`/analytics/scheduled-reports`, data);
}
export function updateScheduledReport(id, data) {
  return api.patch(`/analytics/scheduled-reports/${id}`, data);
}
export function deleteScheduledReport(id) {
  return api.delete(`/analytics/scheduled-reports/${id}`);
}

/**
 * COMPANIES
 * --------------
 */
export function getCompanies(params) {
  return api.get(`/companies`, {
    params: {
      ordering: 'name',
      ...params
    }
  });
}

// This function is used to get all companies, reguardless of the user's user_to_company relationship. This endpoint can only be used by Cinch employees.
export function getAllCompanies(params) {
  return api.get(`/companies/all-companies`, {
    params
  });
}
export function getCompany(id, params) {
  return api.get(`/companies/${id}`, {
    params
  });
}
export function getCompanyFields(id) {
  return api.get(`/companies/${id}/fields`);
}
export function getCompanyFlags(id) {
  return api.get(`/companies/${id}/flags`);
}
export function getCompanyPhoneCount(id) {
  return api.get(`/companies/${id}/phone_count`);
}
export function refreshAllCompanyFields(id) {
  return api.post(`/companies/${id}/refresh_fields`);
}
export function getAllCompanyFields(id) {
  return api.get(`/companies/${id}/all_fields`);
}
export function postCompany(data, params) {
  return api.post('/companies', data, {
    params
  });
}
export function patchCompany(id, data) {
  return api.patch(`/companies/${id}`, data);
}
export function offboardCompany(id) {
  return api.delete(`/companies/${id}`);
}
export function getCompanyFiles(id) {
  return api.get(`/company-files/${id}/files`);
}
export function createCompanyFilesFolder(id, folder) {
  return api.post(`/company-files/${id}/folder`, {
    folder
  });
}
export function deleteCompanyFile(id, key) {
  return api.delete(`/company-files/${id}/key?key=${encodeURIComponent(key)}`);
}
export function renameCompanyFile(id, old_key, new_key) {
  return api.post(`/company-files/${id}/rename`, {
    old_key,
    new_key
  });
}
export function downloadCompanyFile(id, key) {
  return api.get(`/company-files/download/${id}?key=${encodeURIComponent(key)}`);
}
export function checkCompanyFields(id, data) {
  return api.post(`/companies/${id}/field_check`, data);
}
export function getCompanyStatuses(params) {
  return api.get(`/companies/statuses`, {
    params
  });
}
export function getCompanyCancelReasons(params) {
  return api.get(`/companies/cancel-reasons`, {
    params
  });
}
export function getAccounts(params) {
  return api.get(`/accounts`, {
    params
  });
}
export function getAccount(id) {
  return api.get(`/accounts/${id}`);
}
export function postAccount(data) {
  return api.post(`/accounts`, data);
}
export function patchAccount(id, data) {
  return api.patch(`/accounts/${id}`, data);
}
export function duplicateCompany(data, id) {
  return api.post(`/companies/${id}/duplicate`, data);
}
export function getApiKeys(companyId) {
  return api.get(`companies/${companyId}/api-keys`);
}
export function createApiKey(companyId, data) {
  return api.post(`companies/${companyId}/api-keys`, data);
}
export function deleteApiKey(companyId, apiKeyId) {
  return api.delete(`companies/${companyId}/api-keys/${apiKeyId}`);
}
export function getCompanyDataDict(companyId, model, field) {
  return api.get(`companies/${companyId}/data-dicts/${model}/${field}`);
}

/**
 * JOURNEYS
 * --------------
 */
export function getJourneys(params) {
  return api.get(`/journeys`, {
    params
  });
}
export function getJourneyTemplates(params) {
  return api.get(`/journeys/templates`, {
    params
  });
}
export function getJourney(journeyId) {
  return api.get(`/journeys/${journeyId}`);
}
export function getJourneyRevisions(journeyId, params) {
  return api.get(`/journeys/${journeyId}/revisions`, {
    params
  });
}
export function getJourneyNodes(revisionId) {
  // We're appending an abort controller to the promise. This allows us to cancel the request.
  const controller = new AbortController();
  const promise = api.get(`/journeys/revisions/${revisionId}`, {
    signal: controller.signal
  });
  promise.controller = controller;
  return promise;
}
export function triggerNodeApproval(id, state) {
  return api.post(`/journeys/nodes/${id}/${state}`);
}
export function getJourneyNode(id, params) {
  return api.get(`/journeys/nodes/${id}`, {
    params
  });
}
export function getNodeTemplates(params) {
  return api.get(`/journeys/nodes/templates`, {
    params
  });
}
export function createNodeTemplate(data) {
  return api.post(`/journeys/nodes/templates`, data);
}
export function getJourneysTags(companyId) {
  return api.get(`/journeys/tags/${companyId}`);
}
export function getJourneyReasons(companyId) {
  return api.get(`/journeys/reasons/${companyId}`);
}
export function getJourneyEndStats(journeyId) {
  return api.get(`/journeys/${journeyId}/end-stats`);
}
export function getJourneySummary(journeyId, params) {
  return api.get(`/journeys/${journeyId}/summary`, {
    params
  });
}
export function createJourney(journey) {
  return api.post(`/journeys`, journey);
}
export function createJourneyFromTemplate(templateId, companyId) {
  return api.post(`/journeys/from_template/${templateId}/to_company/${companyId}`);
}
export function deleteJourney(journeyId) {
  return api.delete(`/journeys/${journeyId}`);
}
export function patchJourney(journeyId, body, params) {
  return api.patch(`/journeys/${journeyId}`, body, {
    params
  });
}
export function patchRevision(revisionId, body) {
  return api.patch(`/journeys/revisions/${revisionId}`, body);
}
export function deleteRevision(revisionId) {
  return api.delete(`/journeys/revisions/${revisionId}`);
}
export function getRevisionAnalytics(revisionId, params) {
  // We're appending an abort controller to the promise.  We may want to always do this but I'm not sure.
  const controller = new AbortController();
  const promise = api.get(`/journeys/revisions/${revisionId}/analytics`, {
    params,
    signal: controller.signal
  });
  promise.controller = controller;
  return promise;
}
export function duplicateJourney(journeyId, company_ids) {
  return api.post(`/journeys/${journeyId}/duplicate`, {
    company_ids
  });
}
export function revertJourney(journeyId) {
  return api.post(`/journeys/${journeyId}/revert`);
}
export function getJourneyTestRuns(params) {
  return api.get(`/journeys/test-runs`, {
    params
  });
}
export function getJourneyTestRun(id) {
  return api.get(`/journeys/test-runs/${id}`);
}
export function createJourneyTestRun(body) {
  return api.post(`/journeys/test-runs`, body);
}

/**
 * NODES
 * --------------
 */
export function createNode(node_type, name, template, x, y, revision, parameters) {
  return api.post(`/journeys/nodes`, {
    node_type,
    name,
    template,
    x,
    y,
    revision,
    parameters
  });
}
export function removeNode(nodeId) {
  return api.delete(`/journeys/nodes/${nodeId}`);
}
export function updateNode(nodeId, body) {
  return api.patch(`/journeys/nodes/${nodeId}`, body);
}
export function testSQL(sql) {
  return api.post(`/journeys/nodes/test-sql`, {
    sql
  });
}
export function testBulkSQL(sql, values, target_database) {
  return api.post(`/journeys/nodes/test-bulk-sql`, {
    sql,
    values,
    target_database
  });
}
export function testWebhookSQL(sql, database, required_field) {
  return api.post(`/journeys/nodes/test-webhook-sql`, {
    sql,
    database,
    required_field
  });
}
export function getNodeCustomers(nodeId, params) {
  return api.get(`/journeys/nodes/${nodeId}/customers`, {
    params
  });
}
export function getNodeCustomersSQL(nodeId, params) {
  return api.get(`/journeys/nodes/${nodeId}/customersSQL`, {
    params
  });
}
export function createNodeCustomersSegment(nodeId, params) {
  return api.post(`/journeys/nodes/${nodeId}/to-segment`, {
    params
  });
}
export function getCheckFieldNodeMetadata(nodeId) {
  return api.get(`/journeys/nodes/${nodeId}/check-field/metadata`);
}
export function getJourneyTimeline(params) {
  return api.get(`/journeys/timeline`, {
    params
  });
}
export function getSegmentNodes(params) {
  return api.get(`/journeys/segment-nodes`, {
    params
  });
}
export function shiftJourneyLayout(revisionId) {
  return api.post(`/journeys/revisions/${revisionId}/shift-layout`);
}

/**
 * JOURNEY LINKS
 * --------------
 */
export function createLink(from_node, to_node, on_event) {
  return api.post(`/journeys/links`, {
    from_node,
    to_node,
    on_event
  });
}
export function updateLink(id, body) {
  return api.patch(`/journeys/links/${id}`, body);
}
export function removeLink(linkId) {
  return api.delete(`/journeys/links/${linkId}`);
}

/**
 * SEGMENTS
 * --------------
 */

export function createCustomerSegment(customerSegment) {
  return api.post('/customer-segments', customerSegment);
}
export function deleteCustomerSegment(id) {
  return api.delete('/customer-segments/' + id);
}
export function segmentConvertToQuery(params) {
  return api.post(`/segments/convert-query`, params);
}
export function getSegments(params) {
  return api.get(`/segments`, {
    params: {
      archived: false,
      ordering: 'name',
      ...params
    }
  });
}
export function getSegment(id, params) {
  return api.get(`/segments/${id}`, {
    params
  });
}
export function getSegmentCustomers(id, params) {
  return api.get(`/segments/${id}/customers`, {
    params
  });
}
export function getSegmentExportCustomers(id, selectedFields) {
  return api.post(`/segments/${id}/customers/export`, {
    selectedFields
  });
}

/**
 * Duplicate Segment
 *
 * Create a new segment using this segment as the source
 *
 * @param {str} id           Segment to use for duplicating
 * @param {list} company_ids Optional. Target companies to put new segment in.
 * @returns Promise
 */
export function duplicateSegment(id, company_ids) {
  return api.post(`/segments/${id}/duplicate`, {
    company_ids
  });
}
export function getSegmentCount(id, params) {
  // We're appending an aprt controller to the promise.  We may want to always do this but I'm not sure.
  const controller = new AbortController();
  const promise = api.get(`/segments/${id}/counts`, {
    params,
    signal: controller.signal
  });
  promise.controller = controller;
  return promise;
}
export function newSegment(segment) {
  return api.post('/segments', segment);
}
export function editSegment(id, segment, params) {
  return api.patch(`/segments/${id}`, segment, {
    params
  });
}
export function copySegment(segment) {
  return api.post('/segments', segment);
}
export function deleteSegment(id) {
  return api.delete(`/segments/${id}`);
}
export function getSegmentExport(id) {
  return api.get(`/segments/${id}/customers.csv`, {
    responseType: 'blob'
  });
}
export function createSegmentFromTemplate(segmentId, companyId) {
  return api.post(`/segments/from-template/${segmentId}/to-company/${companyId}`);
}
export function testSegment(segment) {
  return api.post(`/segments/test-count`, segment);
}
export function getSegmentsTags(companyId) {
  return api.get(`/segments/tags/${companyId}`);
}
export function getSegmentCreatedByUsers(companyId) {
  return api.get(`/segments/created-by/${companyId}`);
}
export function runCustomPicklistSegmentQuery(query) {
  return api.post(`/segments/picklistSQL`, query);
}

/**
 * SEGMENT TEMPLATES
 * --------------
 */
export function getSegmentTemplates(params) {
  return api.get(`/segment-templates`, {
    params
  });
}

/**
 * LOCATIONS
 * --------------
 */
export function getLocations(params) {
  // We're appending an abort controller to the promise. This allows us to cancel the request.
  const controller = new AbortController();
  const promise = api.get(`/locations`, {
    params,
    signal: controller.signal
  });
  promise.controller = controller;
  return promise;
}
export function getLocationResources(params) {
  // We're appending an abort controller to the promise. This allows us to cancel the request.
  const controller = new AbortController();
  const promise = api.get(`/location-resources`, {
    params,
    signal: controller.signal
  });
  promise.controller = controller;
  return promise;
}
export function getLocation(id, params) {
  return api.get(`/locations/${id}`, {
    params
  });
}
export function setLocationRegularHours(id, data) {
  return api.patch(`/locations/${id}/regular-hours`, data);
}
export function createLocation(data) {
  return api.post(`/locations`, data);
}
export function editLocation(id, data) {
  return api.patch(`/locations/${id}`, data);
}
export function createLocationRegularHours(data) {
  return api.post(`/location-regular-hours`, data);
}
export function updateLocationRegularHours(id, data) {
  return api.patch(`/location-regular-hours/${id}`, data);
}
export function deleteLocationRegularHours(id) {
  return api.delete(`/location-regular-hours/${id}`);
}
export function createLocationSpecialHours(data) {
  return api.post(`/location-special-hours`, data);
}
export function updateLocationSpecialHours(id, data) {
  return api.patch(`/location-special-hours/${id}`, data);
}
export function deleteLocationSpecialHours(id) {
  return api.delete(`/location-special-hours/${id}`);
}
export function createLocationExtendedHours(data) {
  return api.post(`/location-extended-hours`, data);
}
export function updateLocationExtendedHours(id, data) {
  return api.patch(`/location-extended-hours/${id}`, data);
}
export function deleteLocationExtendedHours(id) {
  return api.delete(`/location-extended-hours/${id}`);
}
export function getTransactionStats(companyId) {
  return api.get(`locations/transactions/stats?company=${companyId}`);
}
export function exportLocationToCSV(data, params) {
  return api.post(`/locations/export`, data, {
    params
  });
}
export function getLocationsExport(params) {
  return api.get(`/locations.csv`, {
    params
  });
}
export function importLocationsCSV(data) {
  return api.post(`/locations/import`, data);
}
export function bulkUpdateLocations(data) {
  return api.patch(`/locations/bulk`, data);
}

/**
 * LOCATION_REFS
 * --------------
 */
export function bulkUpsertLocationRefs(data) {
  return api.patch(`/location_refs/bulk`, data);
}
export function getLocationRefs(params) {
  return api.get(`/location_refs`, {
    params
  });
}
export function getLocationRef(id, params) {
  return api.get(`/location_refs/${id}`, {
    params
  });
}
export function editLocationRef(id, data) {
  return api.patch(`/location_refs/${id}`, data);
}

/**
 * MARKETS
 * --------------
 */
export function getMarkets(params) {
  return api.get(`/markets`, {
    params
  });
}
export function getMarket(id, params) {
  return api.get(`/markets/${id}`, {
    params
  });
}
export function createMarket(params) {
  return api.post('/markets', params);
}
export function updateMarket(id, params) {
  return api.patch(`/markets/${id}`, params);
}
export function deleteMarket(id) {
  return api.delete(`/markets/${id}`);
}

/**
 * COUPONS
 * --------------
 */
export function getCoupons(params) {
  return api.get(`/coupons`, {
    params
  });
}
export function getCoupon(id, params) {
  return api.get(`/coupons/${id}`, {
    params
  });
}
export function getCouponStats(id, params) {
  return api.get(`/coupons/${id}/stats`, {
    params
  });
}
export function newCoupon(data) {
  return api.post('/coupons', data);
}
export function getCouponBatches(couponId) {
  return api.get(`/coupons/${couponId}/batches`);
}
export function downloadCouponBatch(couponId, batchNumber) {
  return api.get(`/coupons/${couponId}/download-batch/${batchNumber}`);
}
export function createCoupon(data) {
  return api.post('/coupons', data);
}
export function createCouponBatch(id, data) {
  return api.post(`/coupons/${id}/generate-batch`, data);
}
export function uploadCouponCodes(couponId, formData, onUploadProgress) {
  return api.post(`/coupons/${couponId}/upload-codes`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    onUploadProgress: onUploadProgress
  });
}
export function editCoupon(id, data) {
  return api.patch(`/coupons/${id}`, data);
}
export function copyCoupon(body) {
  return api.post('/coupons', buildFormData(body), {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}
export function deleteCoupon(id) {
  return api.delete(`/coupons/${id}`);
}
export function getCouponsTags(companyId) {
  return api.get(`/coupons/tags/${companyId}`);
}
export function getSegmentAssignments(id) {
  return api.get(`/coupons/${id}/segment-assignments`);
}
export function getAllSegmentAssignments(id) {
  return api.get(`/coupons/segment-assignments`);
}
export function updateSegmentAssignments(id, data) {
  return api.post(`/coupons/${id}/assign-segments`, data);
}

/**
 * ROLES
 * --------------
 */
export function getRoles(params) {
  return api.get(`/roles`, {
    params
  });
}
export function getRole(id) {
  return api.get(`/roles/${id}`);
}
export function updateRole(id, role) {
  return api.patch(`/roles/${id}`, role);
}
export function createRole(role) {
  return api.post(`/roles`, role);
}
export function deleteRole(id) {
  return api.delete(`/roles/${id}`);
}

/**
 * USER COMPANIES
 * --------------
 */
export function getUserCompanies(id, params) {
  return api.get(`/users/${id}/companies`, {
    id,
    params
  });
}
export function getUserCompany(id, params) {
  return api.get(`/users/companies/${id}`, {
    params
  });
}
export function deleteUserCompany(id) {
  return api.delete(`/users/companies/${id}`);
}
export function updateUserCompany(id, data) {
  return api.patch(`/users/companies/${id}`, data);
}
export function createUserCompany(data) {
  return api.post(`/users/companies`, data);
}

/**
 * TEMPLATES
 * --------------
 */

//CLEAN THIS AVOID HARD CODE PARAMS
export function getTemplates(params) {
  return api.get(`/templates`, {
    params: {
      ordering: 'name',
      ...params
    }
  });
}
//CLEAN THIS AVOID HARD CODE PARAMS
export function getEmailTemplates(params) {
  return api.get(`templates/emails`, {
    params: {
      ordering: 'name',
      ...params
    }
  });
}
//CLEAN THIS AVOID HARD CODE PARAMS
export function getPrintTemplates(params) {
  return api.get(`templates/prints`, {
    params: {
      ordering: 'name',
      ...params
    }
  });
}
export function getTemplatesTags(companyId) {
  return api.get(`/templates/tags/${companyId}`);
}
export function getSmsTemplates(params) {
  return api.get(`templates/sms`, {
    params: {
      ordering: 'name',
      ...params
    }
  });
}
export function getTemplateCreatedByUsers(companyId) {
  return api.get(`/templates/created-by/${companyId}`);
}
export function getTemplateChangelogIds(id) {
  return api.get(`/templates/${id}/changelog-ids`);
}

/**
 * TEMPLATES - EMAILS
 * --------------
 */

export function getEmail(id) {
  return api.get(`templates/emails/${id}`);
}
export function postEmail(body) {
  return api.post(`/templates/emails`, body);
}
export function getEmailRevision(id) {
  return api.get(`templates/email-revisions/${id}`);
}
export function createEmailRevision(body) {
  return api.post(`/templates/email-revisions`, body);
}
export function updateEmailRevision(id, body) {
  return api.patch(`/templates/email-revisions/${id}`, body);
}
export function patchEmail(id, body, params) {
  return api.patch(`/templates/emails/${id}`, body, {
    params
  });
}
export function deleteEmail(id) {
  return api.delete(`/templates/emails/${id}`);
}
export function bulkUpdateEmailNameAddress(email, name, company_id) {
  return api.post(`/templates/emails/bulk-update-name-address`, {
    email,
    name,
    company_id
  });
}
export function getEmailRevisionLogs(params) {
  return api.get(`/email-revision-logs`, {
    params
  });
}
export function createPreviewInvite({
  email,
  segment,
  company,
  password
}) {
  return api.post(`/previewlink/invites`, {
    email: email,
    segment: segment,
    company: company,
    password: password
  });
}
export function getPreviewInvite(data) {
  return api.post(`/previewlink/invites/preview`, data);
}

/**
 * Duplicate Email
 *
 * Create a new email using this email as the source
 *
 * @param {str} id           Email to use for duplicating
 * @param {list} company_ids Optional. Target companies to put new email in.
 * @returns Promise
 */
export function duplicateEmail(id, company_ids) {
  return api.post(`/templates/emails/${id}/duplicate`, {
    company_ids
  });
}
export function createEmailFromTemplate(templateId, companyId) {
  return api.post(`/templates/emails/from-template/${templateId}/to-company/${companyId}`);
}

/**
 * TEMPLATES - EMAIL TEMPLATES
 * --------------
 */
export function getEmailTemplateTemplates(params) {
  return api.get(`/email-templates`, {
    params: {
      ordering: 'email__name',
      ...params
    }
  });
}
export function getPremadeBlocksTemplate(params) {
  return api.get(`/email-blocks/get`, {
    params
  });
}
export function createPremadeBlocksTemplate(block) {
  return api.post(`/email-blocks`, block);
}
export function updatePremadeBlocksTemplate(id, savedBlock) {
  return api.patch(`/email-blocks/${id}`, savedBlock);
}
export function deletePremadeBlocksTemplate(id, savedBlock) {
  return api.delete(`/email-blocks/${id}`, savedBlock);
}

/**
 * TEMPLATES - MAILS
 * --------------
 */
export function getMail(id) {
  return api.get(`templates/prints/${id}`);
}
export function postPrints(body) {
  return api.post(`/templates/prints`, body);
}
export function patchPrints(id, body, params) {
  return api.patch(`/templates/prints/${id}`, body, params);
}
export function getPrintRevision(id) {
  return api.get(`templates/print-revisions/${id}`);
}
export function createPrintRevision(body) {
  return api.post(`/templates/print-revisions`, body);
}
export function createPrintRevisionFromDraft(id) {
  return api.post(`/templates/print-revisions/${id}/duplicate`);
}
export function updatePrintRevision(id, body) {
  return api.patch(`/templates/print-revisions/${id}`, body);
}
export function deleteMail(id) {
  return api.delete(`/templates/prints/${id}`);
}
export function duplicateMail(id, company_ids) {
  return api.post(`/templates/prints/${id}/duplicate`, {
    company_ids
  });
}
export function createPrintFromTemplate(templateId, companyId) {
  return api.post(`/templates/prints/from-template/${templateId}/to-company/${companyId}`);
}
export function getMailBoxDetails(id) {
  return api.get(`mail/details/${id}`);
}
export function populatePreviewData(id, params) {
  return api.get(`/templates/print-revisions/${id}/preview`, {
    params
  });
}

/**
 * TEMPLATES - PRINT TEMPLATES
 * --------------
 */
export function getPrintTemplateTemplates(params) {
  return api.get(`/print-templates`, {
    params: {
      ordering: 'name',
      ...params
    }
  });
}

/**
 * TEMPLATES - SMS
 * --------------
 */

export function getSms(id) {
  return api.get(`templates/sms/${id}`);
}
export function postSms(body) {
  return api.post(`/templates/sms`, body);
}
export function getSmsRevision(id) {
  return api.get(`templates/sms-revisions/${id}`);
}
export function createSmsRevision(body) {
  return api.post(`/templates/sms-revisions`, body);
}
export function updateSmsRevision(id, body) {
  return api.patch(`/templates/sms-revisions/${id}`, body);
}
export function patchSms(id, body, params) {
  return api.patch(`/templates/sms/${id}`, body, {
    params
  });
}
export function deleteSms(id) {
  return api.delete(`/templates/sms/${id}`);
}
export function duplicateSms(id, company_ids) {
  return api.post(`/templates/sms/${id}/duplicate`, {
    company_ids
  });
}
export function getSmsTemplateTemplates(params) {
  return api.get(`/sms-templates`, {
    params: {
      ordering: 'sms__name',
      ...params
    }
  });
}
export function sendTestSmsMessage(data) {
  return api.post(`/templates/sms-revisions/test-sms`, data);
}
export function generatePreview(data) {
  return api.post(`/templates/sms-revisions/generate-preview`, data);
}
export function createSmsFromTemplate(templateId, companyId) {
  return api.post(`/templates/sms/from-template/${templateId}/to-company/${companyId}`);
}
/**
 * CHARGEBEE
 */
export function getChargeBeeCheckoutURL(companyId) {
  return api.get(`/chargebee/hosted/${companyId}/url`);
}
export function getChargeBeeSubscriptionURL(companyId) {
  return api.get(`/chargebee/hosted/${companyId}/portal`);
}
export function createChargeBeeSubscription(data) {
  return api.post(`/chargebee/subscription`, data);
}
export function getChargeBeeSubscription(company) {
  return api.get('/chargebee/subscription', {
    params: {
      company
    }
  });
}
export function getChargeBeeAddons(company) {
  return api.get(`/chargebee/company/${company}/addons`);
}
export function getChargeBeePlan(company) {
  return api.get(`/chargebee/company/${company}/plan`);
}

/**
 * MANAGED EMAIL BROADCASTS
 *
 * Where applicable, these endpoints leverage the
 * ManagedBroadcastRequestBuilder to construct the params
 */
export function getManagedBroadcasts(params) {
  return api.get(`/broadcasts/managed`, {
    params
  });
}
export function createManagedBroadcast(requestBody) {
  return api.post(`/broadcasts/managed`, requestBody);
}
export function deleteManagedBroadcast(id) {
  return api.delete(`/broadcasts/managed/${id}`);
}
export function updateManagedBroadcast(id, requestBody) {
  return api.patch(`/broadcasts/managed/${id}`, requestBody);
}

/*
 * EMAIL BROADCAST
 */

export function getBroadcast(id, params) {
  return api.get(`/broadcasts/${id}`, {
    params
  });
}
export function getBroadcasts(params) {
  return api.get(`/broadcasts`, {
    params
  });
}
export function createBroadcast(body) {
  return api.post(`/broadcasts`, body);
}
export function updateBroadcast(id, body) {
  return api.patch(`/broadcasts/${id}`, body);
}
export function deleteBroadcast(id) {
  return api.delete(`/broadcasts/${id}`);
}
export function getBroadcastsLogs(params) {
  return api.get(`/broadcasts/logs`, {
    params
  });
}
export function getEstimatedBroadcastSends(params) {
  return api.get(`/broadcasts/estimated-sends`, {
    params
  });
}
export function createReBroadcast(body) {
  return api.post(`/broadcasts/create-rebroadcast`, body);
}

/*
 * SMS BROADCAST
 */

export function getSmsBroadcast(id, params) {
  return api.get(`/communication/sms/broadcasts/${id}`, {
    params
  });
}
export function getSmsBroadcasts(params) {
  return api.get(`/communication/sms/broadcasts`, {
    params
  });
}
export function createSmsBroadcast(body) {
  return api.post(`/communication/sms/broadcasts`, body);
}
export function updateSmsBroadcast(id, body) {
  return api.patch(`/communication/sms/broadcasts/${id}`, body);
}
export function deleteSmsBroadcast(id) {
  return api.delete(`/communication/sms/broadcasts/${id}`);
}

/**
 * SMS
 */
export function getPhoneNumbers(params) {
  return api.get(`/communication/phone-number`, {
    params
  });
}
export function postHostNumber(data) {
  return api.post(`/communication/phone-number/host`, data);
}
export function getAvailablePhoneNumbers(params) {
  return api.get(`/communication/phone-number/available`, {
    params
  });
}
export function refreshPhoneRegistration(company, service) {
  return api.get(`/communication/phone-number/refresh`, {
    params: {
      company,
      service
    }
  });
}
export function getPhoneRegistration(company, service) {
  return api.get(`/communication/phone-number/registration`, {
    params: {
      company,
      service
    }
  });
}
export function updateBusinessInformation(data) {
  return api.post(`/communication/phone-number/business_information`, data);
}
export function getPossibleUseCases(company, service) {
  return api.get(`/communication/phone-number/use_cases`, {
    params: {
      company,
      service
    }
  });
}
export function submitMessageCampaign(data) {
  return api.post(`/communication/phone-number/campaign`, data);
}
export function updateMessageCampaign(data) {
  return api.post(`/communication/phone-number/campaign_draft`, data);
}
export function updateBusinessAddress(data) {
  return api.post(`/communication/phone-number/business_address`, data);
}
export function updateAuthorizedRepresentative(data) {
  return api.post(`/communication/phone-number/authorized_representative`, data);
}
export function updateA2PBusinessInformation(data) {
  return api.post(`/communication/phone-number/a2p_business_information`, data);
}
export function verifyCustomerProfile(company, service) {
  return api.get(`/communication/phone-number/verify`, {
    params: {
      company,
      service
    }
  });
}
export function submitCustomerProfile(company, service) {
  return api.post(`/communication/phone-number/submit`, {
    company,
    service
  });
}
export function submitBrand(company, service) {
  return api.post(`/communication/phone-number/submit_brand`, {
    company,
    service
  });
}
export function verifyA2P(company, service) {
  return api.get(`/communication/phone-number/verify_a2p`, {
    params: {
      company,
      service
    }
  });
}
export function submitA2P(company, service) {
  return api.post(`/communication/phone-number/submit_a2p`, {
    company,
    service
  });
}
export function updatePhoneNumber(id, body) {
  return api.patch(`/communication/phone-number/${id}`, body);
}
export function deletePhoneNumber(id) {
  return api.delete(`/communication/phone-number/${id}`);
}
export function purchasePhoneNumber(data) {
  return api.post(`/communication/phone-number/purchase`, data);
}
export function uploadPhoneNumberLOA(id, formData) {
  return api.post(`/bandwidth/loa/${id}`, formData);
}
export function getMessaging(params) {
  // We're appending an abort controller to the promise. This allows us to cancel the request.
  const controller = new AbortController();
  const promise = api.get(`/communication/sms`, {
    params,
    signal: controller.signal
  });
  promise.controller = controller;
  return promise;
}
export function spoofReply(data) {
  return api.post(`/communication/sms/twilio-reply`, data);
}
export function getSMSLog(id, params) {
  return api.get(`/communication/sms/${id}/timeline`, {
    params
  });
}
export function registerDeviceToFirebase(data) {
  return api.post(`/fcm`, data);
}
export function getSmsMetrics(params) {
  return api.get(`/communication/sms/journey/metrics`, {
    params
  });
}

/**
 * DOMAINS
 */
export function getDomains(params) {
  return api.get(`/email/domains`, {
    params
  });
}
export function createDomains(body) {
  return api.post(`/email/domains`, body);
}
export function verifyDomain(id) {
  return api.post(`/email/domains/${id}/verify`);
}
export function deleteDomain(id) {
  return api.delete(`/email/domains/${id}`);
}

/**
 * EMAIL ADDRESSES
 */
export function getAddresses(params) {
  return api.get(`/email/addresses`, {
    params
  });
}
export function getAddress(id) {
  return api.get(`/email/addresses/${id}`);
}
export function createAddress(body) {
  return api.post(`/email/addresses`, body);
}
export function verifyAddress(id, hash) {
  return api.post(`/email/addresses/${id}/verify/${hash}`);
}
export function resendVerificationEmail(id) {
  return api.post(`/email/addresses/${id}/resend`);
}
export function rejectAddress(id) {
  return api.post(`/email/addresses/${id}/reject`);
}
export function deleteAddress(id) {
  return api.delete(`/email/addresses/${id}`);
}

// EMAIL METRICS

export function getEmailMetrics(node_id, days) {
  return api.get(`/email/journeys/metrics?node_id=${node_id}${days ? `&days=${days}` : ''}`);
}
export function getEmailLog(id) {
  return api.get(`/email/logs/${id}`);
}

/**
 * CSV Imports
 */

export function getImports(params) {
  return api.get(`/integration/csvimport`, {
    params
  });
}
export function getCSVImportSources(params) {
  return api.get(`/integration/csvimport/sources`, {
    params
  });
}
export function importCSV(data) {
  return api.post(`/integration/csvimport`, data);
}
export function previewCSV(data) {
  return api.post('/integration/csvimport/preview', data);
}
export function deleteImport(id) {
  return api.delete(`/integration/csvimport/${id}`);
}
export function stopImport(id, data) {
  return api.patch(`/integration/csvimport/${id}`, data);
}
export function getAICSVMapping(params) {
  return api.get(`/integration/ai-csvimport`, {
    params
  });
}
export function createAICSVMapping(data) {
  return api.post(`/integration/ai-csvimport`, data);
}
export function updateAICSVMapping(id, data) {
  return api.patch(`/integration/ai-csvimport/${id}`, data);
}
export function generateAICSVMapping(data) {
  return api.post(`/integration/ai-csvimport/generate`, data);
}

/**
 * Surveys
 */
export function getSurveys(params) {
  return api.get(`/surveys`, {
    params: {
      archived: false,
      ...params
    }
  });
}
export function getSurvey(id) {
  return api.get(`/surveys/${id}`);
}
export function createSurvey(body) {
  return api.post(`/surveys`, body);
}
export function updateSurvey(id, body) {
  return api.patch(`/surveys/${id}`, body);
}
export function getSurveysTags(companyId) {
  return api.get(`/surveys/tags/${companyId}`);
}
export function deleteSurvey(id) {
  return api.delete(`/surveys/${id}`);
}
export function duplicateSurvey(id, company_ids) {
  return api.post(`/surveys/${id}/duplicate`, {
    company_ids
  });
}
export function getSurveyRevisions(params) {
  return api.get(`/surveys/revisions`, {
    params
  });
}
export function createSurveyRevision(body) {
  return api.post(`/surveys/revisions`, body);
}
export function getSurveyRevision(id) {
  return api.get(`/surveys/revisions/${id}`);
}
export function getSurveyRevisionTotal(id, params) {
  return api.get(`/surveys/revisions/${id}/total`, {
    params
  });
}
export function updateSurveyRevision(id, body) {
  return api.patch(`/surveys/revisions/${id}`, body);
}
export function deleteSurveyRevision(id) {
  return api.delete(`/surveys/revisions/${id}`);
}
export function getSurveyQuestions(params) {
  return api.get(`/surveys/questions`, {
    params
  });
}
export function createSurveyQuestion(body) {
  return api.post(`/surveys/questions`, body);
}
export function getSurveyQuestion(id) {
  return api.get(`/surveys/questions/${id}`);
}
export function updateSurveyQuestion(id, body) {
  return api.patch(`/surveys/questions/${id}`, body);
}
export function deleteSurveyQuestion(id) {
  return api.delete(`/surveys/questions/${id}`);
}
export function getSurveyCustomers(params) {
  return api.get(`/surveys/customers`, {
    params
  });
}
export function getSurveyCustomerAnswers(params) {
  return api.get(`/surveys/customeranswers`, {
    params
  });
}
export function getSurveyTimeline(params) {
  return api.get(`/surveys/customeranswers/timeline`, {
    params
  });
}
export function getRevisionQuestionsSummary(id, params) {
  return api.get(`/surveys/revisions/${id}/summary`, {
    params
  });
}
export function getSurveyInvite(id) {
  return api.get(`/surveys/invites/${id}`);
}
export function getSurveyInviteCustomers(params) {
  return api.get(`/surveys/invites`, {
    params
  });
}

/**
 * Folders
 */

export function getCompanyFolders(params) {
  return api.get(`/folder`, {
    params
  });
}
export function getFolder(id) {
  return api.get(`/folder/${id}`);
}
export function createNewFolder(body) {
  return api.post(`/folder`, body);
}
export function updateFolder(id, body) {
  return api.patch(`/folder/${id}`, body);
}
export function deleteFolder(id) {
  return api.delete(`/folder/${id}`);
}

/**
 * Reviews
 */

export function getReviews(params) {
  return api.get(`/reviews`, {
    params: {
      is_latest: true,
      ...params
    }
  });
}
export function editReview(id, data) {
  return api.patch(`/reviews/${id}`, data);
}
export function sendReviewReply(id, data) {
  return api.post(`/reviews/${id}/reply`, data);
}
export function getReviewsLocations(params) {
  return api.get(`/reviews/locations`, {
    params
  });
}
export function getReviewAiReply(id) {
  return api.post(`/reviews/${id}/ai_reply`);
}
export function getReviewsExport(params) {
  return api.get(`/reviews.csv`, {
    params
  });
}
export function getReviewDetails(id, params) {
  return api.get(`/reviews/${id}/timeline`, {
    params
  });
}
export function exportReviewToCSV(data, params) {
  return api.post(`/reviews/export`, data, {
    params
  });
}
export function getReviewsOverview(params) {
  return api.get(`/reviews/overall-info`, {
    params
  });
}

/**
 * Transactions
 */

export function getTransactions(params) {
  return api.get(`/transactions`, {
    params
  });
}
export function getTransactionsTotals(params) {
  return api.get(`/transactions/totals`, {
    params
  });
}

/**
 * Integration Logs
 */

export function getIntegrationLogs(params) {
  return api.get(`/integration/logs`, {
    params
  });
}
export function getIntegrationSessions(params) {
  return api.get(`/integration/sessions`, {
    params
  });
}

/**
 * Convrrt
 */

export function authenticateConvrrt(data) {
  return api.post(`/integration/convrrt/authenticate`, data);
}
export function getConvrrtPages(params) {
  return api.get(`/integration/convrrt/pages`, {
    params
  });
}

/**
 * Repeat Transaction Calculator
 */

export function getRTCRules(params) {
  return api.get(`/transaction_calculator/rules`, {
    params
  });
}
export function RunRTCCalculator(id, data) {
  return api.post(`/transaction_calculator/rules/${id}/run`, data);
}
export function createRTCRule(rule) {
  return api.post(`/transaction_calculator/rules`, rule);
}
export function getRTCRule(id, params) {
  return api.get(`/transaction_calculator/rules/${id}`, {
    params
  });
}
export function updateRTCRule(id, data) {
  return api.patch(`/transaction_calculator/rules/${id}`, data);
}
export function deleteRTCRule(id) {
  return api.delete(`/transaction_calculator/rules/${id}`);
}
export function getRTCAggregate(rule) {
  return api.post(`/transaction_calculator/rules/aggregate`, rule);
}
export function getRTCSample(rule) {
  return api.post(`/transaction_calculator/rules/sample`, rule);
}
export function getRTCResults(params) {
  return api.get(`/transaction_calculator/results`, {
    params
  });
}
export function duplicateRTCRule(id) {
  return api.post(`/transaction_calculator/rules/${id}/duplicate`);
}

/**
 * Motor OEM Recommendations
 */
export function getMotorOemRecommendation(id) {
  return api.get(`/motor_oem_recommendations/recommendations/${id}`);
}
export function getMotorOemRecommendations(params) {
  return api.get(`/motor_oem_recommendations/recommendations`, {
    params
  });
}
export function getMotorOemConfig(id) {
  return api.get(`/motor_oem_recommendations/config/${id}`);
}
export function createMotorOemConfig(body) {
  return api.post(`/motor_oem_recommendations/config`, body);
}
export function updateMotorOemConfig(id, body) {
  return api.patch(`/motor_oem_recommendations/config/${id}`, body);
}
export function finalizeMotorOemConfig(id) {
  return api.post(`/motor_oem_recommendations/config/${id}/finalize`);
}
export function deleteMotorOemConfig(id) {
  return api.delete(`/motor_oem_recommendations/config/${id}`);
}
export function getMotorOemConfigs(params) {
  return api.get(`/motor_oem_recommendations/config`, {
    params
  });
}
export function getMotorOemConfigDetails(params) {
  return api.get(`/motor_oem_recommendations/config/details`, {
    params
  });
}
export function createMotorOemConfigDetail(body) {
  return api.post(`/motor_oem_recommendations/config/details`, body);
}
export function deleteMotorOemConfigDetail(id) {
  return api.delete(`/motor_oem_recommendations/config/details/${id}`);
}
export function updateMotorOemConfigDetail(id, body) {
  return api.patch(`/motor_oem_recommendations/config/details/${id}`, body);
}

/**
 * ProductBoard
 */

export function authenticateProductBoard(data) {
  return api.post(`/integration/productboard/authenticate`, data);
}

/**
 * Launch Darkly
 */

export function addUserToLaunchDarklySegment(data) {
  return api.post(`/integration/launchdarkly/add-user-to-segment`, data);
}
export function removeUserFromLaunchDarklySegment(data) {
  return api.post(`/integration/launchdarkly/remove-user-from-segment`, data);
}

/* export function isUserInLaunchDarklySegment(params) {
  return api.get(`/integration/launchdarkly/is-user-in-segment`, { params });
} */

/**
 * Action Items
 */

export function getActionItems(params) {
  return api.get(`/integration/actionitems/action-items`, {
    params
  });
}

/**
 * Prebuilts
 */

export function getPrebuilts(params) {
  return api.get(`/prebuilt/list`, {
    params
  });
}

/**
 * Prebuilt Segments
 */

export function getPrebuiltSegment(id, params) {
  return api.get(`/prebuilt/segments/${id}`, {
    params
  });
}
export function getPrebuiltSegments(params) {
  return api.get(`/prebuilt/segments`, {
    params
  });
}
export function createPrebuiltSegmentFromSegment(data) {
  return api.post(`/prebuilt/segments/copy`, data);
}
export function createPrebuiltSegmentVersionFromSegment(data) {
  return api.post(`/prebuilt/segments/versions/copy`, data);
}
export function patchPrebuiltSegment(id, data) {
  return api.patch(`/prebuilt/segments/${id}`, data);
}
export function getPrebuiltSegmentVersion(id, params) {
  return api.get(`/prebuilt/segments/versions/${id}`, {
    params
  });
}
export function getPrebuiltSegmentVersions(params) {
  return api.get(`/prebuilt/segments/versions`, {
    params
  });
}
export function patchPrebuiltSegmentVersion(id, data) {
  return api.patch(`/prebuilt/segments/versions/${id}`, data);
}
export function replacePrebuiltSegmentVersionAvailability(data) {
  return api.post(`/prebuilt/segments/availability/bulk/replace`, data);
}
export function getPrebuiltSegmentsTags() {
  return api.get(`/prebuilt/segments/tags`);
}
export function getPrebuiltSegmentCreatedByUsers() {
  return api.get(`/prebuilt/segments/created-by`);
}
export function getPrebuiltSegmentMetadata(id) {
  return api.get(`/prebuilt/segments/${id}/metadata`);
}
export function releasePrebuiltSegmentVersion(id) {
  return api.post(`/prebuilt/segments/versions/${id}/release`);
}
export function archivePrebuiltSegment(id) {
  return api.delete(`/prebuilt/segments/${id}`);
}
export function getPrebuiltSegmentInstalls(params) {
  return api.get(`/prebuilt/segments/installs`, {
    params
  });
}
export function pushPrebuiltSegmentUpdate(id, data) {
  return api.post(`/prebuilt/segments/${id}/push-update`, data);
}
export function createPrebuiltSegmentInstall(id, data) {
  return api.post(`/prebuilt/segments/versions/${id}/install`, data);
}

/**
 * Prebuilt Email
 */

export function getPrebuiltEmail(id, params) {
  return api.get(`/prebuilt/emails/${id}`, {
    params
  });
}
export function getPrebuiltEmails(params) {
  return api.get(`/prebuilt/emails`, {
    params
  });
}
export function createPrebuiltEmailFromEmailRevision(data) {
  return api.post(`/prebuilt/emails/copy`, data);
}
export function createPrebuiltEmailVersionFromEmailRevision(data) {
  return api.post(`/prebuilt/emails/versions/copy`, data);
}
export function patchPrebuiltEmail(id, data) {
  return api.patch(`/prebuilt/emails/${id}`, data);
}
export function getPrebuiltEmailMetadata(id) {
  return api.get(`/prebuilt/emails/${id}/metadata`);
}
export function pushPrebuiltEmailUpdate(id, data) {
  return api.post(`/prebuilt/emails/${id}/push-update`, data);
}
export function getPrebuiltEmailVersion(id, params) {
  return api.get(`/prebuilt/emails/versions/${id}`, {
    params
  });
}
export function getPrebuiltEmailVersions(params) {
  return api.get(`/prebuilt/emails/versions`, {
    params
  });
}
export function patchPrebuiltEmailVersion(id, data) {
  return api.patch(`/prebuilt/emails/versions/${id}`, data);
}
export function replacePrebuiltEmailVersionAvailability(data) {
  return api.post(`/prebuilt/emails/availability/bulk/replace`, data);
}
export function getPrebuiltEmailsTags() {
  return api.get(`/prebuilt/emails/tags`);
}
export function getPrebuiltEmailCreatedByUsers() {
  return api.get(`/prebuilt/emails/created-by`);
}
export function releasePrebuiltEmailVersion(id) {
  return api.post(`/prebuilt/emails/versions/${id}/release`);
}
export function archivePrebuiltEmail(id) {
  return api.delete(`/prebuilt/emails/${id}`);
}
export function getPrebuiltEmailInstalls(params) {
  return api.get(`/prebuilt/emails/installs`, {
    params
  });
}
export function createPrebuiltEmailInstall(id, data) {
  return api.post(`/prebuilt/emails/versions/${id}/install`, data);
}

/**
 * Prebuilt Sms
 */

export function getPrebuiltSms(id, params) {
  return api.get(`/prebuilt/sms/${id}`, {
    params
  });
}
export function getPrebuiltSmsList(params) {
  return api.get(`/prebuilt/sms`, {
    params
  });
}
export function createPrebuiltSmsFromSmsRevision(data) {
  return api.post(`/prebuilt/sms/copy`, data);
}
export function createPrebuiltSmsVersionFromSmsRevision(data) {
  return api.post(`/prebuilt/sms/versions/copy`, data);
}
export function patchPrebuiltSms(id, data) {
  return api.patch(`/prebuilt/sms/${id}`, data);
}
export function getPrebuiltSmsMetadata(id) {
  return api.get(`/prebuilt/sms/${id}/metadata`);
}
export function pushPrebuiltSmsUpdate(id, data) {
  return api.post(`/prebuilt/sms/${id}/push-update`, data);
}
export function getPrebuiltSmsVersion(id, params) {
  return api.get(`/prebuilt/sms/versions/${id}`, {
    params
  });
}
export function getPrebuiltSmsVersions(params) {
  return api.get(`/prebuilt/sms/versions`, {
    params
  });
}
export function patchPrebuiltSmsVersion(id, data) {
  return api.patch(`/prebuilt/sms/versions/${id}`, data);
}
export function replacePrebuiltSmsVersionAvailability(data) {
  return api.post(`/prebuilt/sms/availability/bulk/replace`, data);
}
export function getPrebuiltSmsTags() {
  return api.get(`/prebuilt/sms/tags`);
}
export function getPrebuiltSmsCreatedByUsers() {
  return api.get(`/prebuilt/sms/created-by`);
}
export function releasePrebuiltSmsVersion(id) {
  return api.post(`/prebuilt/sms/versions/${id}/release`);
}
export function archivePrebuiltSms(id) {
  return api.delete(`/prebuilt/sms/${id}`);
}
export function getPrebuiltSmsInstalls(params) {
  return api.get(`/prebuilt/sms/installs`, {
    params
  });
}
export function createPrebuiltSmsInstall(id, data) {
  return api.post(`/prebuilt/sms/versions/${id}/install`, data);
}

/**
 * Prebuilt Print
 */

export function getPrebuiltPrint(id, params) {
  return api.get(`/prebuilt/prints/${id}`, {
    params
  });
}
export function getPrebuiltPrints(params) {
  return api.get(`/prebuilt/prints`, {
    params
  });
}
export function createPrebuiltPrintFromPrintRevision(data) {
  return api.post(`/prebuilt/prints/copy`, data);
}
export function createPrebuiltPrintVersionFromPrintRevision(data) {
  return api.post(`/prebuilt/prints/versions/copy`, data);
}
export function patchPrebuiltPrint(id, data) {
  return api.patch(`/prebuilt/prints/${id}`, data);
}
export function getPrebuiltPrintMetadata(id) {
  return api.get(`/prebuilt/prints/${id}/metadata`);
}
export function getPrebuiltPrintVersion(id, params) {
  return api.get(`/prebuilt/prints/versions/${id}`, {
    params
  });
}
export function getPrebuiltPrintVersions(params) {
  return api.get(`/prebuilt/prints/versions`, {
    params
  });
}
export function patchPrebuiltPrintVersion(id, data) {
  return api.patch(`/prebuilt/prints/versions/${id}`, data);
}
export function replacePrebuiltPrintVersionAvailability(data) {
  return api.post(`/prebuilt/prints/availability/bulk/replace`, data);
}
export function getPrebuiltPrintsTags() {
  return api.get(`/prebuilt/prints/tags`);
}
export function getPrebuiltPrintCreatedByUsers() {
  return api.get(`/prebuilt/prints/created-by`);
}
export function releasePrebuiltPrintVersion(id) {
  return api.post(`/prebuilt/prints/versions/${id}/release`);
}
export function archivePrebuiltPrint(id) {
  return api.delete(`/prebuilt/prints/${id}`);
}
export function getPrebuiltPrintInstalls(params) {
  return api.get(`/prebuilt/prints/installs`, {
    params
  });
}
export function pushPrebuiltPrintUpdate(id, data) {
  return api.post(`/prebuilt/prints/${id}/push-update`, data);
}
export function createPrebuiltPrintInstall(id, data) {
  return api.post(`/prebuilt/prints/versions/${id}/install`, data);
}

/**
 * Prebuilt Survey
 */

export function getPrebuiltSurvey(id, params) {
  return api.get(`/prebuilt/surveys/${id}`, {
    params
  });
}
export function getPrebuiltSurveys(params) {
  return api.get(`/prebuilt/surveys`, {
    params
  });
}
export function createPrebuiltSurveyFromSurveyRevision(data) {
  return api.post(`/prebuilt/surveys/copy`, data);
}
export function createPrebuiltSurveyVersionFromSurveyRevision(data) {
  return api.post(`/prebuilt/surveys/versions/copy`, data);
}
export function patchPrebuiltSurvey(id, data) {
  return api.patch(`/prebuilt/surveys/${id}`, data);
}
export function getPrebuiltSurveyMetadata(id) {
  return api.get(`/prebuilt/surveys/${id}/metadata`);
}
export function pushPrebuiltSurveyUpdate(id, data) {
  return api.post(`/prebuilt/surveys/${id}/push-update`, data);
}
export function getPrebuiltSurveyVersion(id, params) {
  return api.get(`/prebuilt/surveys/versions/${id}`, {
    params
  });
}
export function getPrebuiltSurveyVersions(params) {
  return api.get(`/prebuilt/surveys/versions`, {
    params
  });
}
export function patchPrebuiltSurveyVersion(id, data) {
  return api.patch(`/prebuilt/surveys/versions/${id}`, data);
}
export function replacePrebuiltSurveyVersionAvailability(data) {
  return api.post(`/prebuilt/surveys/availability/bulk/replace`, data);
}
export function getPrebuiltSurveysTags() {
  return api.get(`/prebuilt/surveys/tags`);
}
export function getPrebuiltSurveyCreatedByUsers() {
  return api.get(`/prebuilt/surveys/created-by`);
}
export function releasePrebuiltSurveyVersion(id) {
  return api.post(`/prebuilt/surveys/versions/${id}/release`);
}
export function archivePrebuiltSurvey(id) {
  return api.delete(`/prebuilt/surveys/${id}`);
}
export function getPrebuiltSurveyInstalls(params) {
  return api.get(`/prebuilt/surveys/installs`, {
    params
  });
}
export function createPrebuiltSurveyInstall(id, data) {
  return api.post(`/prebuilt/surveys/versions/${id}/install`, data);
}

/**
 * Prebuilt Journey
 */

export function getPrebuiltJourney(id, params) {
  return api.get(`/prebuilt/journeys/${id}`, {
    params
  });
}
export function getPrebuiltJourneys(params) {
  return api.get(`/prebuilt/journeys`, {
    params
  });
}
export function createPrebuiltJourneyFromJourneyRevision(data) {
  return api.post(`/prebuilt/journeys/copy`, data);
}
export function createPrebuiltJourneyVersionFromJourneyRevision(data) {
  return api.post(`/prebuilt/journeys/versions/copy`, data);
}
export function patchPrebuiltJourney(id, data) {
  return api.patch(`/prebuilt/journeys/${id}`, data);
}
export function getPrebuiltJourneyVersion(id, params) {
  return api.get(`/prebuilt/journeys/versions/${id}`, {
    params
  });
}
export function getPrebuiltJourneyVersions(params) {
  return api.get(`/prebuilt/journeys/versions`, {
    params
  });
}
export function patchPrebuiltJourneyVersion(id, data) {
  return api.patch(`/prebuilt/journeys/versions/${id}`, data);
}
export function replacePrebuiltJourneyVersionAvailability(data) {
  return api.post(`/prebuilt/journeys/availability/bulk/replace`, data);
}
export function getPrebuiltJourneysTags() {
  return api.get(`/prebuilt/journeys/tags`);
}
export function getPrebuiltJourneyCreatedByUsers() {
  return api.get(`/prebuilt/journeys/created-by`);
}
export function releasePrebuiltJourneyVersion(id) {
  return api.post(`/prebuilt/journeys/versions/${id}/release`);
}
export function archivePrebuiltJourney(id) {
  return api.delete(`/prebuilt/journeys/${id}`);
}
export function getPrebuiltJourneyInstalls(params) {
  return api.get(`/prebuilt/journeys/installs`, {
    params
  });
}
export function pushPrebuiltJourneyUpdate(id, data) {
  return api.post(`/prebuilt/journeys/${id}/push-update`, data);
}
export function createPrebuiltJourneyInstall(id, data) {
  return api.post(`/prebuilt/journeys/versions/${id}/install`, data);
}
export function getPrebuiltJourneyVersionMetaData(id) {
  return api.get(`/prebuilt/journeys/versions/${id}/node/metadata`);
}

/**
 * Widgets
 */

export function getWidgetInstalls(params) {
  return api.get(`/widgets/installs`, {
    params
  });
}
export function getAvailableWidgets(params) {
  return api.get(`/widgets/availability`, {
    params
  });
}
export function createWidgetInstall(data) {
  return api.post(`/widgets/installs`, data);
}
export function getJourneyVolumesWidget(companyId) {
  return api.get(`/widgets/journey-volumes/${companyId}`);
}
export function getEmailStatsWidget(companyId) {
  return api.get(`/widgets/email-stats/${companyId}`);
}
export function getReviewStatsWidget(companyId) {
  return api.get(`/widgets/review-stats/${companyId}`);
}

// CIN-6303: Task Manager dashboard widgets.
export function getMyTasksWidget(companyId) {
  return api.get(`/widgets/tasks-my/${companyId}`);
}
export function getTasksOverviewWidget(companyId) {
  return api.get(`/widgets/tasks-overview/${companyId}`);
}
export function deleteWidgetInstall(id) {
  return api.delete(`/widgets/installs/${id}`);
}
export function patchWidgetInstall(id, data) {
  return api.patch(`/widgets/installs/${id}`, data);
}

/**
 * AI Segment Integration
 */
export function generateAiSegment(data) {
  return api.post(`/integration/ai-segment/generate`, data);
}

/**
 * Carfax Reviews Integration
 */

export function getCarfaxReviewLocations() {
  return api.get(`/integration/carfax-reviews/locations`);
}

/**
 * Release Notes
 */

export function getReleaseNotes(params) {
  return api.get(`/releasenotes`, {
    params
  });
}
export function createReleaseNote(data) {
  return api.post(`/releasenotes`, data);
}
export function patchReleaseNote(id, data) {
  return api.patch(`/releasenotes/${id}`, data);
}
export function deleteReleaseNote(id) {
  return api.delete(`/releasenotes/${id}`);
}
export function createReleaseNoteLog(data) {
  return api.post(`/releasenotes/log`, data);
}

/**
 * Pestpac
 */
export function syncAllPestpacCsv(credentialId) {
  return api.post(`/integration/pestpac/csv/sync`, {
    credential: credentialId
  });
}
export function syncSinglePestpacCsv(id) {
  return api.post(`/integration/pestpac/csv/${id}/sync`);
}
export function getPestPacCsvHistory(params) {
  return api.get(`/integration/pestpac/csv`, {
    params
  });
}
export function createPestpacCsv(data) {
  return api.post(`/integration/pestpac/csv`, data);
}
export function updatePestpacCsv(id, data) {
  return api.patch(`/integration/pestpac/csv/${id}`, data);
}
export function getPestpacCsv(id) {
  return api.get(`/integration/pestpac/csv/${id}`);
}
export function getPestpacCsvs(params) {
  return api.get(`/integration/pestpac/csv`, {
    params
  });
}
export function resyncPestpacLocations(body) {
  return api.post(`/integration/pestpac/locations/sync`, body);
}

// TODO make sure entity_source='pestpac' functions in locations....
// Pestpac has a custom filter specific to itself due to data conflicts
export function getPestPacLocations(params) {
  return api.get(`/integration/pestpac/locations`, {
    params
  });
}

// Clean little call that just simply flips the right bit for us
export function activeTogglePestPacLocation(id) {
  return api.post(`/integration/pestpac/locations/${id}/active/toggle`);
}

/**
 * Pestpac webhook controls
 */
export function getPestPacWebhookControls(params) {
  return api.get(`/integration/pestpac/webhook-control`, {
    params
  });
}
export function getPestPacWebhookControl(id) {
  return api.get(`/integration/pestpac/webhook-control/${id}`);
}
export function updatePestPacWebhookControl(id, data) {
  return api.patch(`/integration/pestpac/webhook-control/${id}`, data);
}

/**
 * Pestpac webhook subscriptions
 */

export function togglePestPacWebhookSubscription(id, data) {
  return api.patch(`/integration/pestpac/webhook-subscription/${id}/toggle`);
}

/**
 * Integration Data Fields
 */

export function setDataFieldsFromIntegration(integration_id, company_id, method) {
  /**
   * @param {int} integration_id
   * @param {int} company_id
   * @param {string} method - merge or replace
   *
   * merge - combine the data fields from the integration with the existing data fields for the company
   * replace - replace the existing data fields for the company with the data fields from the integration
   */

  return api.post(`/integration/integrations/${integration_id}/datafields`, {
    company_id,
    method
  });
}

/**
 * DRB Carwash
 */

export function getDRBCarwashLogs(params) {
  return api.get(`/integration/drbcarwash`, {
    params
  });
}
export function processDRBWashCsv(data) {
  return api.post(`/integration/drbcarwash/sync`, data);
}

/**
 * HubSpot Integration
 */

export function getHubSpotDeals(params) {
  return api.get(`/integration/hubspot/deals`, {
    params
  });
}
export function getHubSpotDeal(dealId) {
  return api.get(`/integration/hubspot/deals/${dealId}`);
}
export function authorizeHubSpot(code) {
  return api.post(`/integration/hubspot/authorize`, {
    code
  });
}

/**
 * PandaDoc Integration
 */

export function getPandaDocByHSDealID(dealId, params) {
  return api.get(`/integration/pandadoc/hubspot-deal/${dealId}`, {
    params
  });
}

/**
 * ChangeLog
 */

/*
export function getChangeLog(id, params) {
  return api.get(`/changelog/${id}`, { params });
} */

export function getChangeLogs(params) {
  return api.get(`/changelog`, {
    params
  });
}

/**
 * Employee Portal
 */

export function getAccessRequests(params) {
  //Since this uses enanced table to render,
  // and it automatically inserts the company id,
  // we dont want to pass up companyid
  if (params.company) {
    delete params.company;
  }
  return api.get(`/users/access-request`, {
    params
  });
}
export function createAccessRequest(data) {
  return api.post(`/users/access-request`, data);
}
export function getAccessRequestFilters(params) {
  return api.get(`/users/access-request/request-filters`, {
    params
  });
}
export function patchAccessRequest(id, data) {
  return api.patch(`/users/access-request/${id}`, data);
}
export function deleteAccessRequest(id) {
  return api.delete(`/users/access-request/${id}`);
}
export function revokeAcessRequest(data) {
  return api.post(`/users/access-request/revoke-access`, data);
}

/**
 * Notes
 * --------------
 * These are used to save notes per the object type.
 * The object type can be anything like 'customer', 'company', etc.
 * The notes are stored in a generic way and can be retrieved based on the object type.
 */
export function getNotes(params) {
  return api.get(`/notes`, {
    params
  });
}
export function createNote(data) {
  return api.post(`/notes`, data);
}
export function deleteNote(id) {
  return api.delete(`/notes/${id}`);
}
export function updateNote(id, data) {
  return api.patch(`/notes/${id}`, data);
}

//Availability

export function getAvailabilityRules(params) {
  return api.get(`/availability/rule`, {
    params
  });
}
export function createAvailabilityRule(data) {
  return api.post(`/availability/rule`, data);
}
export function updateAvailabilityRule(id, data) {
  return api.patch(`/availability/rule/${id}`, data);
}
export function runAvailabilityRule(id, data) {
  return api.post(`/availability/rule/${id}/run_now`, data);
}
export function deleteAvailabilityRule(id) {
  return api.delete(`/availability/rule/${id}`);
}
export function getAvailabilityLookups(params) {
  return api.get(`/availability/lookup`, {
    params
  });
}
export function getGroupedAvailabilityLookups(params) {
  return api.get(`/availability/lookup/grouped`, {
    params
  });
}
export function testAvailabilityRule(data) {
  return api.post(`/availability/rule/test`, data);
}
export function getAvailabilityRule(id, params) {
  return api.get(`/availability/rule/${id}`, {
    params
  });
}

//Recommendations

export function getRecommendations(params) {
  return api.get(`/recommendations`, {
    params
  });
}
export function getRecommendationTags(params) {
  return api.get(`/recommendations/tags`, {
    params
  });
}
export function patchRecommendation(id, data) {
  return api.patch(`/recommendations/${id}`, data);
}
export function deleteRecommendation(id) {
  return api.delete(`/recommendations/${id}`);
}
export function createRecommendation(data) {
  return api.post(`/recommendations`, data);
}
export function getRecommendation(id, params) {
  return api.get(`/recommendations/${id}`, {
    params
  });
}
export function getRecommendationTargetObject(params) {
  return api.get(`/recommendations/target-object`, {
    params
  });
}

//Inactives

export function getInactives(params) {
  return api.get(`/inactive`, {
    params
  });
}
export function getInactive(id) {
  return api.get(`/inactive/${id}`);
}

// AI Voice Agent (elevenlabs)

// configuration aka 1:1 with voice agent
export function getVoiceAgentConfig(id) {
  return api.get(`integration/voice-agent/configuration/${id}`);
}
export function getVoiceAgentConfigs(params) {
  return api.get(`integration/voice-agent/configuration`, {
    params
  });
}
export function createVoiceAgentConfig(data) {
  return api.post(`integration/voice-agent/configuration`, data);
}
export function updateVoiceAgentConfig(id, data) {
  return api.patch(`integration/voice-agent/configuration/${id}`, data);
}
export function deleteVoiceAgentConfig(id) {
  return api.delete(`integration/voice-agent/configuration/${id}`);
}

// configuration locations aka the details of the configuration per location
export function getVoiceAgentConfigLocations(params) {
  return api.get(`integration/voice-agent/configuration/location`, {
    params
  });
}
export function getVoiceAgentConfigLocation(id) {
  return api.get(`integration/voice-agent/configuration/location/${id}`);
}
export function createVoiceAgentConfigLocation(data) {
  return api.post(`integration/voice-agent/configuration/location`, data);
}
export function updateVoiceAgentConfigLocation(id, data) {
  return api.patch(`integration/voice-agent/configuration/location/${id}`, data);
}
export function updateVoiceAgentConfigLocationLanguages(id, data) {
  return api.patch(`integration/voice-agent/configuration/location/${id}/languages`, data);
}
export function getVoiceAgentConfigLocationBehaviors(params) {
  return api.get(`/integration/voice-agent/configuration/location/behavior`, {
    params
  });
}
export function updateVoiceAgentConfigBehavior(id, data) {
  return api.patch(`integration/voice-agent/configuration/location/behavior/${id}`, data);
}
export function bulkUpdateVoiceAgentConfigBehaviors(data) {
  return api.patch('integration/voice-agent/configuration/location/behavior/bulk-update', data);
}
export function duplicateVoiceAgentConfigLocation(id, data) {
  return api.post(`integration/voice-agent/configuration/${id}/duplicate`, data);
}
export function bulkDuplicateVoiceAgentConfigLocation(id, data) {
  return api.post(`integration/voice-agent/configuration/${id}/bulk-duplicate`, data);
}

// custom endpoints
export function getElevenLabsSignedURL(configuration_id) {
  return api.get(`integration/voice-agent/configuration/${configuration_id}/get_signed_url`);
}
export function getVoiceAgentCallHistories(params) {
  return api.get(`integration/voice-agent/call-history`, {
    params
  });
}

// Hate to have to add params but needed for generating some context
export function getVoiceAgentCallHistory(id, params) {
  return api.get(`integration/voice-agent/call-history/${id}`, {
    params
  });
}
export function getVoiceAgentCallHistoryAnalytics(params) {
  return api.get(`integration/voice-agent/call-history/analytics`, {
    params
  });
}
export function getVoiceAgentCallHistoryTranscript(params) {
  return api.get(`/integration/voice-agent/call-history/transcripts`, {
    params
  });
}

// Connecting / Disconnecting phone number for agent.
export function connectVoiceAgentPhone(id, data) {
  return api.post(`integration/voice-agent/configuration/location/${id}/phone/connect`, data);
}
export function disconnectVoiceAgentPhone(id) {
  return api.post(`integration/voice-agent/configuration/location/${id}/phone/disconnect`);
}

// Previewing an Agent Voice
// export function previewVoiceAgentVoice(data) {
//   return api.post(`integration/voice-agent/tools/preview-voice`, data);
// }
export function previewVoiceAgentVoice(configId, data) {
  return api.post(`integration/voice-agent/configuration/location/${configId}/preview-voice`, data, {
    responseType: 'blob'
  });
}

// Website scanning for voice agent configuration
export function analyzeCompanyWebsite(data) {
  return api.post(`integration/voice-agent/website-analyzer/analyze-company`, data);
}

//Get Conversation Audio from Call History
export function getVoiceAgentConversationAudio(data) {
  return api.post(`integration/voice-agent/conversation-audio/get_audio`, data, {
    responseType: 'blob'
  });
}

/**
 * VEHICLE MOTOR API
 * --------------
 */
export function getVehicleYears() {
  return api.get('/motor/years');
}
export function getVehicleMakesByYear(year) {
  return api.get(`/motor/makes?year=${year}`);
}
export function getVehicleModelsByYearAndMake(year, makeId) {
  return api.get(`/motor/models?year=${year}&make_id=${makeId}`);
}

/**
 * CINCH TASK MANAGER
 * --------------
 * Endpoints for the Cinch Task Manager integration. List returns the standard
 * DRF `{count, next, previous, results}` paginated envelope; detail/mutate
 * return the bare TaskManager dict.
 */

/**
 * List tasks (paginated).
 * @param {object} params - DRF list params (company, search, ordering, filters).
 * @returns {Promise<{data: {count: number, results: object[]}}>}
 */
export function getTasks(params) {
  return api.get(`/cinch_task_manager/tasks`, {
    params
  });
}

/**
 * Fetch a single task by id.
 * @param {string} id - Task UUID.
 * @returns {Promise<{data: object}>}
 */
export function getTask(id) {
  return api.get(`/cinch_task_manager/tasks/${id}`);
}

/**
 * Create a task. Required: company, name, assigned_to.
 * @param {object} data - TaskManager payload.
 * @returns {Promise<{data: object}>}
 */
export function createTask(data) {
  return api.post(`/cinch_task_manager/tasks`, data);
}

/**
 * Partially update a task.
 * @param {string} id - Task UUID.
 * @param {object} body - Subset of writable fields.
 * @returns {Promise<{data: object}>}
 */
export function patchTask(id, body) {
  return api.patch(`/cinch_task_manager/tasks/${id}`, body);
}

/**
 * Soft-delete a task (DeleteWhenModelViewSet — sets deleted_when).
 * @param {string} id - Task UUID.
 * @returns {Promise<{data: object}>}
 */
export function deleteTask(id) {
  return api.delete(`/cinch_task_manager/tasks/${id}`);
}

/**
 * Mark a task complete by moving it into the company's terminal stage. Idempotent —
 * already-terminal is a silent 200. Fires the journey-engine stage event for the
 * source customer node. (CIN-6288)
 * @param {string} id - Task UUID.
 * @returns {Promise<{data: object}>}
 */
export function completeTask(id) {
  return api.post(`/cinch_task_manager/tasks/${id}/complete`);
}

// --- Task Manager: Stages (CIN-6288) ---

/** List a company's task workflow stages, ordered by sort_order. */
export function getTaskStages(params) {
  return api.get(`/cinch_task_manager/stages`, {
    params
  });
}

/** Fetch a single stage by id (resolves a journey link's stage path label). */
export function getTaskStage(id) {
  return api.get(`/cinch_task_manager/stages/${id}`);
}

/** Create a stage. Required: company, name. sort_order is auto-assigned. */
export function createTaskStage(data) {
  return api.post(`/cinch_task_manager/stages`, data);
}

/** Partially update a stage (rename, recolor, is_terminal). */
export function patchTaskStage(id, body) {
  return api.patch(`/cinch_task_manager/stages/${id}`, body);
}

/** Soft-delete a stage (blocked for the terminal stage or one with active tasks). */
export function deleteTaskStage(id) {
  return api.delete(`/cinch_task_manager/stages/${id}`);
}

/** Bulk-reorder stages. body: { items: [{ id, sort_order }, ...] }. */
export function reorderTaskStages(body) {
  return api.post(`/cinch_task_manager/stages/reorder`, body);
}

// --- Task Manager: Categories (CIN-6288) ---

/** List a company's managed task categories (the tag picklist). */
export function getTaskCategories(params) {
  return api.get(`/cinch_task_manager/categories`, {
    params
  });
}

/** Create a category. Required: company, name. */
export function createTaskCategory(data) {
  return api.post(`/cinch_task_manager/categories`, data);
}

/** Partially update a category (rename/recolor). */
export function patchTaskCategory(id, body) {
  return api.patch(`/cinch_task_manager/categories/${id}`, body);
}

/** Soft-delete a category (removed from the picklist; tasks keep the name). */
export function deleteTaskCategory(id) {
  return api.delete(`/cinch_task_manager/categories/${id}`);
}

// --- Task Manager: Config (CIN-6288) ---

/** Fetch a company's Task Manager config (auto-archive policy). The backend
 *  auto-creates a default row, so the results contain one config object. */
export function getTaskManagerConfig(params) {
  return api.get(`/cinch_task_manager/config`, {
    params
  });
}

/** Update a config row (auto_archive_enabled, auto_archive_days). */
export function patchTaskManagerConfig(id, body) {
  return api.patch(`/cinch_task_manager/config/${id}`, body);
}